export enum EhrTypeEnum {
  DoctorPrescriptionTypeId = 1,
  UploadedPrescriptionTypeId,
  TestRequestTypeId,
  PatientMedicationTypeId,
  DiagnosisTypeId,
  AllergyTypeId,
  DiseaseTypeId,
  PatientTestTypeId
}

export enum UploadedPrescriptionType {
  TpaRequestUploadedPrescriptionTypeId = 1,
  PrescriptionFulfillmentUploadedPrescriptionTypeId,
  UploadedPrescriptionUploadedPrescriptionTypeId
}
